export const FONT_FAMILY_MAIN = "'Muli', 'Trebuchet MS', Tahoma, helvetica, arial, sans-serif;";
export const TEXT_COLOR = '#354354';
export const LINKS_COLOR = '#4a90e2';
export const PALE_GREY = '#eef1f6';
export const LIGHT_PALE_GREY = '#fafafb';
export const BLUE_GREY = '#9aa1a9';
export const ERROR_COLOR = '#f74656';
export const SUCCESS_COLOR = '#51e3ae';
export const NOTES_COLOR = '#68727f';
export const LIGHT_BLUE_GREY = '#ccd0d4';
export const MAIN_BLUE = '#4a90e2';
export const LIGHT_BLUE = '#a6c8f0';
export const DARK_BLUE = '#124483';
export const PALE_CORNFLOWER_BLUE = '#c8ddf6';
export const ALICE_BLUE = '#f3f8ff';
export const SOLITUDE = '#e5eaf2';
export const GRAY_CHATEAU = '#979ea7';
export const COBALT = '#0153b4';
export const SILVER = '#ccd0d4';
export const TABLES_LIGHT_STYLE_HOVER = '#f4f7f9';

export const INPUT_BORDERS_COLOR = 'rgba(0, 0, 0, 0.07)';

export const BIG_SCREEN_CONTENT_WIDTH = '1160px';
export const MEDIUM_SCREEN_CONTENT_WIDTH = '960px';
